import {configureStore} from "@reduxjs/toolkit"
import {userDataReducer} from "./module/userData";
import {hostDataReducer} from "./module/hostData";

export let store

//初始化
export default function initStore() {
    store = configureStore({
        reducer: {
            userData: userDataReducer,
            hostData: hostDataReducer
        }
    })

    return store
}